import EfBanner from '@elem/ui/ef-banner';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.Banner');

    const configs = {
        title: t('title'),
        desc: t('desc'),
        pc: 'https://websiteoss.ecoflow.com/upload/image/1732592507156/head-pc%20.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1732592507146/head-h5.jpg',
        btn_text: t('btn'),
        btn_link: 'https://www.youtube.com/embed/_xbFUQ4b1fQ',
    };

    return (
        <div className={styles.TheComp}>
            <EfBanner {...configs} theme="black" />
        </div>
    );
}
